/* Konfigurator C+ - rysunek frontu w skali + przełączniki opcji (redesign 2026-09-23).
   Tylko CZYTA stan z DOM konfiguratora (aktywne kafelki, pola mm, selecty opcji) i rysuje SVG.
   Nie dotyka ceny, wariantu ani koszyka - to robi konfigurator-natywny.js.
   Jedyny zapis: przełączniki (.knf__seg) ustawiają wartość ukrytego selecta i wysyłają "change",
   dokładnie tak, jak gdyby klient wybrał opcję z listy. */
(function () {
  const root = document.querySelector("[data-knf]");
  const sheet = root && root.querySelector("[data-knf-sheet]");
  if (!sheet) return;
  const svg = sheet.querySelector("svg");
  const cap = sheet.querySelector("[data-knf-sheet-cap]");
  const note = sheet.querySelector(".knf__sheet-note");
  const identStyle = root.querySelector("[data-knf-ident-style]");
  const identSub = root.querySelector("[data-knf-ident-sub]");
  const TEX = JSON.parse(sheet.dataset.tex || "{}");
  Object.keys(TEX).forEach(n => { if (typeof TEX[n] === "string") TEX[n] = { u: TEX[n], w: 600, h: 900 }; });
  let styles = [];
  try { styles = (JSON.parse(root.dataset.styles).styles) || []; } catch (e) {}
  const catOf = n => (styles.find(s => s.name === n) || {}).category || "lakier";

  const txt = el => (el ? el.textContent.trim() : "");
  const cond = label => {
    const s = root.querySelector(`select[data-knf-cond="${label}"]`);
    return s ? s.value : "";
  };
  // skad wymiar do rysunku: "tile" = kafelek ostatnio dodany, "input" = pola mm formularza „Inny wymiar”
  let dimSrc = "tile";
  root.addEventListener("click", e => {
    const t = e.target.closest && e.target.closest(".knf__tile .knf__preset, [data-knf-custom-add]");
    if (t) dimSrc = t.matches("[data-knf-custom-add], .knf__preset--custom") ? "input" : "tile";
  }, true);
  root.addEventListener("input", e => { if (e.target.matches && e.target.matches("[data-knf-szer], [data-knf-wys]")) dimSrc = "input"; }, true);

  function readState() {
    const st = root.querySelector(".knf__style.is-active");
    const col = root.querySelector(".knf__color.is-active");
    const sample = root.classList.contains("knf--sample-mode");
    let szer = parseInt(root.querySelector("[data-knf-szer]")?.value, 10) || 0;
    let wys = parseInt(root.querySelector("[data-knf-wys]")?.value, 10) || 0;
    // tryb zestawu: rysunek = ostatnio dodany kafelek (.knf__tile.is-active), chyba ze klient ostatnio wpisywal „Inny wymiar”
    const tile = (dimSrc === "tile" || szer < 40 || wys < 40) && root.querySelector(".knf__tile.is-active > .knf__preset[data-szer-mm][data-wys-mm]");
    if (tile && !sample) { szer = parseInt(tile.dataset.szerMm, 10) || szer; wys = parseInt(tile.dataset.wysMm, 10) || wys; }
    if (sample) {
      const m = txt(root.querySelector("[data-knf-sample-dim-value]")).match(/(\d+)\D+(\d+)/);
      if (m) { szer = +m[1]; wys = +m[2]; }
    }
    let hex = "";
    let customOn = !!(col && col.classList.contains("knf__color--custom"));
    if (col && !customOn) hex = col.style.getPropertyValue("--kclr").trim();
    if (customOn) {   // kolor z palety RAL/ICA/F&B (knf-palety.js) albo wpisany kod, ktory pasuje do palety: rysujemy prawdziwy odcien
      const ci = root.querySelector("[data-knf-kolor-custom]");
      const ph = (ci && ci.dataset.hex) || (window.knfPalHex && ci ? window.knfPalHex(ci.value) : "");
      if (ph) { hex = ph; customOn = false; }
    }
    // 04.10.2026: kierunek slojow wymuszony jak w pozycji zestawu (cokol w drewnie zawsze poziomo, element < 10 cm wzdluz)
    const fGrain = window.knfForcedGrain ? window.knfForcedGrain(root.querySelector("[data-knf-typ]")?.value || "", szer, wys) : "";
    const grubSel = root.querySelector("[data-knf-grubosc]");
    const grub = grubSel && !grubSel.disabled ? parseInt(grubSel.value, 10) || 18 : ((st && window.knfStyleThickness && window.knfStyleThickness(st.dataset.style)) || 18);
    return {
      style: st ? st.dataset.style : "",
      styleLabel: st ? txt(st.querySelector(".knf__style-name")) : "",
      hex, colorLabel: col ? txt(col.querySelector(".knf__color-name")) : "",
      custom: root.querySelector("[data-knf-kolor-custom]")?.value.trim() || "",
      szer, wys, sample,
      sys: txt(root.querySelector(".knf__syschip.is-active .knf__syschip-label")),
      typ: txt(root.querySelector(".knf__typchip.is-active .knf__typchip-label")),
      gloss: sample ? root.querySelector("[data-knf-sample-finish]:checked")?.value === "Połysk" : /^Połysk/.test(cond("Wykończenie")),
      loc: cond("Lokalizacja uchwytu") || "Góra",
      locCustom: /^Niestandardow/.test(cond("Lokalizacja uchwytu")) || /^(Cok[oó]ł|Panel|Listwa|Blenda)/.test(root.querySelector("[data-knf-typ]")?.value || ""),
      hinge: (() => { const h = root.querySelector('select[data-knf-cond="Strona zawiasów"]'); return h && !h.closest(".knf__col")?.hidden ? h.value : ""; })(),
      customOn, grub,
      horiz: fGrain ? fGrain === "Poziomy" : cond("Kierunek usłojenia") === "Poziomy",
      // 10.2026 (S7): typy wirtualne zestawu (karta narożnika / nadstawki) - bez podpisu wymiarów, bo tu nie wybiera się wymiaru frontu
      virt: /^(Narożnik|Nadstawka)$/.test(root.querySelector("[data-knf-typ]")?.value || "")
    };
  }

  function mix(hex, t) {
    const n = parseInt(hex.slice(1), 16), r = n >> 16, g = n >> 8 & 255, b = n & 255, m = t < 0 ? 0 : 255, a = Math.abs(t);
    const f = c => Math.round(c + (m - c) * a).toString(16).padStart(2, "0");
    return "#" + f(r) + f(g) + f(b);
  }
  const lum = hex => { const n = parseInt(hex.slice(1), 16); return (.299 * (n >> 16) + .587 * (n >> 8 & 255) + .114 * (n & 255)) / 255; };

  /* Rysunek frontu z przodu, w mm. Wymiary frezow wg specyfikacji z 24.09.2026 (scratchpad/frezy-spec.md):
     ramy maja STALA szerokosc w mm, swiatlo z lewej-gory - wglebienie: cien u gory/z lewej, jasno u dolu/z prawej;
     podniesienie odwrotnie. Grubosc linii w mm, z dolnym limitem w pikselach (k = mm na piksel ekranu). */
  // Konrad 24.09: Hampton, Shaker i Wieden ponizej 14 cm (wysokosc albo szerokosc) robimy gladkie - rama sie nie miesci
  const SMOOTH_LOW = { "Hampton": 1, "Shaker": 1, "Wiedeń": 1 };
  const smoothLow = (style, W, H) => !!SMOOTH_LOW[style] && W > 0 && H > 0 && Math.min(W, H) < 140;
  const LOW_TXT = { pl: "poniżej 14 cm wersja gładka", en: "under 14 cm: plain version", de: "unter 14 cm glatte Ausführung", cs: "pod 14 cm hladké provedení" }[root.dataset.locale] || "poniżej 14 cm wersja gładka";

  function frontSVG(S, W, H, k, P = "knf-") {
    const wood = catOf(S.style) !== "lakier";
    const base = /^#[0-9a-f]{6}$/i.test(S.hex) ? S.hex : "#ECEBE6";
    const dark = lum(base) < .3;
    const SH = mix(base, dark ? -.45 : -.26), HL = mix(base, dark ? .22 : .5), MID = mix(base, -.07);
    const lw = mm => Math.max(mm, .9 * k);
    const horiz = S.horiz, loc = S.loc, noHandle = S.locCustom;
    let g = "", defs = "";
    const ln = (x1, y1, x2, y2, c, w) => `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${c}" stroke-width="${w}" stroke-linecap="square"/>`;
    const rect = (x, y, w, h, f, extra = "") => `<rect x="${x}" y="${y}" width="${Math.max(0, w)}" height="${Math.max(0, h)}" fill="${f}"${extra}/>`;
    // krawedz pola obnizonego (uskok): cien u gory i z lewej, swiatlo u dolu i z prawej
    const stepDown = (x, y, w, h, t = 1.6) => rect(x, y, w, h, MID) + ln(x, y, x + w, y, SH, lw(t)) + ln(x, y, x, y + h, SH, lw(t)) + ln(x, y + h, x + w, y + h, HL, lw(t * .8)) + ln(x + w, y, x + w, y + h, HL, lw(t * .8));
    // krawedz podniesienia: swiatlo u gory i z lewej, cien u dolu i z prawej
    const raise = (x, y, w, h, t = 1.4) => ln(x, y, x + w, y, HL, lw(t)) + ln(x, y, x, y + h, HL, lw(t)) + ln(x, y + h, x + w, y + h, SH, lw(t)) + ln(x + w, y, x + w, y + h, SH, lw(t));
    // rowek V o szerokosci gw: ciemna scianka od strony gory/lewej, jasna od dolu/prawej
    const vGroove = (x1, y1, x2, y2, gw) => {
      const v = x1 === x2, o = gw / 4;
      return v ? rect(x1 - gw / 2, y1, gw, y2 - y1, MID) + ln(x1 - o, y1, x1 - o, y2, SH, lw(gw / 2)) + ln(x1 + o, y1, x1 + o, y2, HL, lw(gw / 3))
               : rect(x1, y1 - gw / 2, x2 - x1, gw, MID) + ln(x1, y1 - o, x2, y1 - o, SH, lw(gw / 2)) + ln(x1, y1 + o, x2, y1 + o, HL, lw(gw / 3));
    };
    // frez prosty (plaskie dno): wyrazne scianki, ciemniejsze dno
    const uGroove = (x, y1, y2, gw) => rect(x - gw / 2, y1, gw, y2 - y1, mix(base, -.1)) + ln(x - gw / 2, y1, x - gw / 2, y2, SH, lw(.9)) + ln(x + gw / 2, y1, x + gw / 2, y2, HL, lw(.7));
    // fazka 45 st. wokol obnizonego pola: gorna i lewa sciana w cieniu, dolna i prawa w swietle
    const bevel = (x, y, w, h, b) => {
      const poly = (pts, f) => `<polygon points="${pts.map(q => q.join(",")).join(" ")}" fill="${f}"/>`;
      return poly([[x, y], [x + w, y], [x + w - b, y + b], [x + b, y + b]], mix(base, -.2)) + poly([[x, y], [x + b, y + b], [x + b, y + h - b], [x, y + h]], mix(base, -.13))
        + poly([[x, y + h], [x + b, y + h - b], [x + w - b, y + h - b], [x + w, y + h]], mix(base, .35)) + poly([[x + w, y], [x + w, y + h], [x + w - b, y + h - b], [x + w - b, y + b]], mix(base, .2));
    };
    const rectGroove = (x, y, w, h, gw) => vGroove(x, y, x + w, y, gw) + vGroove(x, y + h, x + w, y + h, gw) + vGroove(x, y, x, y + h, gw) + vGroove(x + w, y, x + w, y + h, gw);
    // uchwyty: wspolrzedne (u wzdluz krawedzi, v w glab frontu) -> (x, y) dla wybranej krawedzi
    const L = (loc === "Lewa" || loc === "Prawa") ? H : W;
    const map = (u, v) => ({ "Dół": [u, H - v], "Lewa": [v, u], "Prawa": [W - v, u] }[loc] || [u, v]);
    const pt = (u, v) => map(u, v).join(",");
    const gradAcross = (id, v0, v1, stops) => {
      const [x1, y1] = map(0, v0), [x2, y2] = map(0, v1);
      defs += `<linearGradient id="${id}" gradientUnits="userSpaceOnUse" x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}">${stops.map(([o, c]) => `<stop offset="${o}" stop-color="${c}"/>`).join("")}</linearGradient>`;
    };

    // --- plaszczyzna
    const T = wood && S.tex !== false ? TEX[S.style] : null;   // knfMini: tex=false = bez skanu (sam kolor drewna)
    if (T) {
      // okleina i sklejka: prawdziwy skan arkusza w skali mm (California Trading), ulozony normalnie - bez odbijania.
      // Front szerszy niz arkusz dostaje obok kolejny lisc (jak w paczce okleiny). Sloje poziome = wzor obrocony o 90 st.
      // Miniatury (prefiks knf-t) biora maly plik "m", zeby telefon nie ladowal pelnych skanow dla 7 kafelkow.
      const thumb = /^knf-(t|z)\d/.test(P) && T.m;
      const u = thumb ? T.m : T.u, lw0 = thumb ? T.tw : T.w, lh0 = thumb ? T.th : T.h;
      const Wf = horiz ? H : W, Lf = horiz ? W : H;
      const ox = (Wf - lw0) / 2 - Math.ceil(Math.max(0, (Wf - lw0) / 2) / lw0) * lw0, oy = (Lf - Math.min(Lf, lh0)) / 2;
      const rot = horiz ? `translate(${W},0) rotate(90) ` : "";
      defs += `<pattern id="${P}vn" patternUnits="userSpaceOnUse" width="${lw0}" height="${lh0}" patternTransform="${rot}translate(${ox},${oy})"><image href="${u}" width="${lw0}" height="${lh0}" preserveAspectRatio="none"/></pattern>`;
      g += rect(0, 0, W, H, `url(#${P}vn)`);
    } else {
      g += rect(0, 0, W, H, wood ? "#C9B08A" : base, ' rx="1"');
      if (!wood && S.customOn) {  // kolor wpisany recznie (RAL/NCS/F&B): neutralny wzor zamiast udawania odcienia
        defs += `<pattern id="${P}hx" width="${14 * k}" height="${14 * k}" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="${14 * k}" stroke="#000" stroke-opacity=".07" stroke-width="${5 * k}"/></pattern>`;
        g += rect(0, 0, W, H, `url(#${P}hx)`);
      }
    }
    // rama: ramiaki stale, poprzeczki zwezaja sie na niskich szufladach (pole min. ~90-100 mm)
    const frame = (st, minField = 100, minRail = 30) => [st, Math.max(minRail, Math.min(st, (H - minField) / 2))];

    switch (smoothLow(S.style, W, H) ? "Gładki" : S.style) {
      case "Gładki":
        g += raise(.5, .5, W - 1, H - 1, .8);
        break;
      case "Linea": {                                   // plaska rama 12 mm, pole obnizone uskokiem
        g += stepDown(12, 12, W - 24, H - 24, 1.4);
        break;
      }
      case "Monako": {                                  // Konrad 24.09: plycina = kieszen w ramie 61,5 mm, 3,2 mm w glab, krawedz pod 45 st.
        const [fw, fr] = frame(61.5, 100, 35);
        if (W - 2 * fw < 20 || H - 2 * fr < 20) { g += raise(.5, .5, W - 1, H - 1, .8); break; }   // wer3: za waski na plycine - bez odwroconego pola
        g += rect(fw, fr, W - 2 * fw, H - 2 * fr, MID) + bevel(fw, fr, W - 2 * fw, H - 2 * fr, 3.2);
        break;
      }
      case "Pasmo": {                                   // frez prosty 6 mm (4 mm w glab); szerokosc dzielona na pola ~24 mm (597 mm = 25 frezowan), rowek na srodku pola
        const n = Math.max(2, Math.round(W / 24)), p = W / n;
        for (let i = 0; i < n; i++) g += uGroove((i + .5) * p, 0, H, 6);
        break;
      }
      case "Rytm": {                                    // gesty ryfel, rozstaw ~12 mm, zlobienia zaokraglone
        const Lr = horiz ? H : W, n = Math.max(4, Math.round(Lr / 12)), p = Lr / n;
        defs += `<linearGradient id="${P}rg" x1="0" x2="1" y1="0" y2="0"><stop offset="0" stop-color="${base}"/><stop offset=".3" stop-color="${base}"/><stop offset=".36" stop-color="${SH}"/><stop offset=".62" stop-color="${MID}"/><stop offset=".92" stop-color="${HL}"/><stop offset="1" stop-color="${base}"/></linearGradient>`;
        defs += `<pattern id="${P}ry" patternUnits="userSpaceOnUse" width="${p}" height="${horiz ? W : H}"${horiz ? ` patternTransform="translate(${W},0) rotate(90)"` : ""}><rect width="${p}" height="${horiz ? W : H}" fill="url(#${P}rg)"/></pattern>`;
        g += rect(0, 0, W, H, `url(#${P}ry)`);
        break;
      }
      case "Grip": {                                    // kieszen otwarta na krawedz: 36 mm w glab, konczy sie 50 mm od bokow frontu (Konrad 24.09)
        if (noHandle) break;
        const d = 36, R = 14, u0 = Math.max(0, Math.min(50, (L - 2 * R) / 2)), u1 = L - u0;   // bardzo waski front: kieszen min. 2R
        gradAcross(`${P}gp`, 0, d, [[0, mix(base, -.1)], [.72, mix(base, -.14)], [.9, SH], [1, mix(base, -.34)]]);
        g += `<path d="M${pt(u0, 0)} L${pt(u0, d - R)} Q${pt(u0, d)} ${pt(u0 + R, d)} L${pt(u1 - R, d)} Q${pt(u1, d)} ${pt(u1, d - R)} L${pt(u1, 0)} Z" fill="url(#${P}gp)"/>`;
        g += `<path d="M${pt(u0 + R, d + .8)} L${pt(u1 - R, d + .8)}" stroke="${HL}" stroke-width="${lw(1)}" fill="none"/>`;
        break;
      }
      case "Round": case "Round Oak": {                 // Konrad 24.09: kolko O50 mm; 09.10: 50 mm od krawedzi do POCZATKU kolka (srodek 75)
        if (noHandle) break;
        const r = 25, off = 50 + r;
        const [cx, cy] = { "Dół": [W / 2, H - off], "Lewa": [off, off], "Prawa": [W - off, off],   // Lewa/Prawa: stare zapisy
          "Lewa góra": [off, off], "Prawa góra": [W - off, off], "Lewa dół": [off, H - off], "Prawa dół": [W - off, H - off] }[loc] || [W / 2, off];
        defs += `<radialGradient id="${P}rd" cx=".62" cy=".64" r=".78"><stop offset="0" stop-color="${mix(base, .1)}"/><stop offset=".55" stop-color="${mix(base, -.06)}"/><stop offset="1" stop-color="${mix(base, -.34)}"/></radialGradient>`;
        g += `<circle cx="${cx}" cy="${cy}" r="${r}" fill="url(#${P}rd)"/>`;
        if (S.style === "Round Oak" && TEX["Dąb"]) {
          const ri = r - 3.5, D0 = TEX["Dąb"], th = /^knf-(t|z)\d/.test(P) && D0.m, D = th ? { u: D0.m, w: D0.tw, h: D0.th } : D0;
          defs += `<clipPath id="${P}ch"><circle cx="${cx}" cy="${cy}" r="${ri}"/></clipPath>`;
          g += `<g clip-path="url(#${P}ch)"><image href="${D.u}" x="${cx - D.w / 2}" y="${cy - D.h / 2}" width="${D.w}" height="${D.h}" preserveAspectRatio="none"${horiz ? ` transform="rotate(90 ${cx} ${cy})"` : ""}/></g>`;
          g += `<circle cx="${cx}" cy="${cy}" r="${ri}" fill="none" stroke="${mix(base, -.3)}" stroke-width="${lw(.8)}"/>`;
        }
        g += `<path d="M${cx - r * .7} ${cy + r * .7} A${r} ${r} 0 0 1 ${cx + r * .7} ${cy - r * .7}" fill="none" stroke="${SH}" stroke-width="${lw(1.2)}"/>`
          + `<path d="M${cx + r * .7} ${cy - r * .7} A${r} ${r} 0 0 1 ${cx - r * .7} ${cy + r * .7}" fill="none" stroke="${HL}" stroke-width="${lw(1)}"/>`;
        break;
      }
      case "Frezowany uchwyt": {                        // frez na calej krawedzi: 29 mm do najnizszego miejsca, 25 mm do gornej krawedzi podciecia
        if (noHandle) break;
        const d = 29, s = 4;
        gradAcross(`${P}fu`, 0, d, [[0, mix(base, -.08)], [(d - s) / d, mix(base, -.12)], [(d - s + 1) / d, mix(base, -.42)], [1, mix(base, -.3)]]);
        g += `<polygon points="${pt(0, 0)} ${pt(L, 0)} ${pt(L, d)} ${pt(0, d)}" fill="url(#${P}fu)"/>`;
        const [a1, b1] = map(0, d + .8), [a2, b2] = map(L, d + .8);
        g += ln(a1, b1, a2, b2, HL, lw(1.2));
        break;
      }
      case "Hampton": {                                 // 16 mm + 3 mm wybrzuszenia (19 mm), rama 50 mm (IKEA STENSUND); ponizej 14 cm gladki (smoothLow)
        const fw = 50, pw = W - 2 * fw, ph = H - 2 * fw;
        const n = Math.floor(pw / 50);                                  // Konrad 24.09: linie 1,5 mm, „dzieli przez 50 bez reszty” (396 mm = 5 kresek), rowno
        g += raise(.5, .5, W - 1, H - 1, .7) + rect(fw, fw, pw, ph, mix(base, .02)) + raise(fw, fw, pw, ph, 1.8);
        for (let i = 1; i <= n; i++) { const x = fw + i * pw / (n + 1); g += vGroove(x, fw + 1, x, H - fw - 1, 1.5); }
        break;
      }
      case "Quadro":                                    // rowek 20 mm od krawedzi, 2 mm w glab, 45 st. = 4 mm na licu
        g += rectGroove(20, 20, W - 40, H - 40, 4);
        break;
      case "Shaker": {                                  // rama 60 mm, fazka 45 st. 3 mm do obnizonego pola
        const [fw, fr] = frame(60, 90, 40);
        if (W - 2 * fw < 20 || H - 2 * fr < 20) { g += raise(.5, .5, W - 1, H - 1, .8); break; }
        g += rect(fw, fr, W - 2 * fw, H - 2 * fr, MID) + bevel(fw, fr, W - 2 * fw, H - 2 * fr, 3);
        break;
      }
      case "Wiedeń": {                                  // rama 60, profil 9, plaski pas 18, faza 20, pole podniesione
        // Konrad 24.09: pelny profil takze na niskich frontach (np. 20 cm) - najpierw wezsza rama (min. 25), potem wezszy pas i faza;
        // ponizej 14 cm front jest gladki (smoothLow)
        const pr = 9, minField = 40;
        const fit = D => { let f = 60, k = 1; if (D < 2 * (f + pr + 38) + minField) f = Math.max(25, (D - minField - 2 * (pr + 38)) / 2);
          if (D < 2 * (f + pr + 38) + minField) k = Math.max(.25, (D - minField - 2 * (f + pr)) / 76); return [f, k]; };
        const [fw, kw] = fit(W), [fr, kh] = fit(H), kk = Math.min(kw, kh), fl = 18 * kk, bv = 20 * kk;
        g += raise(1.5, 1.5, W - 3, H - 3, .8);
        g += ln(fw, 0, fw, fr, SH, lw(.7)) + ln(W - fw, 0, W - fw, fr, SH, lw(.7)) + ln(fw, H - fr, fw, H, SH, lw(.7)) + ln(W - fw, H - fr, W - fw, H, SH, lw(.7));
        const x0 = fw, y0 = fr, x1 = W - fw, y1 = H - fr;
        g += stepDown(x0, y0, x1 - x0, y1 - y0, 1.6);                           // profil ramy w dol
        g += rect(x0 + pr, y0 + pr, x1 - x0 - 2 * pr, y1 - y0 - 2 * pr, mix(base, -.05));   // plaski pas obnizony
        const a0 = pr + fl, a1 = pr + fl + bv;
        const X0 = x0 + a0, Y0 = y0 + a0, X1 = x1 - a0, Y1 = y1 - a0, I0 = x0 + a1, J0 = y0 + a1, I1 = x1 - a1, J1 = y1 - a1;
        g += `<polygon points="${X0},${Y0} ${X1},${Y0} ${I1},${J0} ${I0},${J0}" fill="${mix(base, .14)}"/>`
          + `<polygon points="${X0},${Y0} ${I0},${J0} ${I0},${J1} ${X0},${Y1}" fill="${mix(base, .06)}"/>`
          + `<polygon points="${X1},${Y0} ${X1},${Y1} ${I1},${J1} ${I1},${J0}" fill="${mix(base, -.12)}"/>`
          + `<polygon points="${X0},${Y1} ${I0},${J1} ${I1},${J1} ${X1},${Y1}" fill="${mix(base, -.2)}"/>`;
        g += rect(I0, J0, I1 - I0, J1 - J0, base) + raise(I0, J0, I1 - I0, J1 - J0, .6);
        break;
      }
      case "Witryna": {                                 // wg zdjec ogony.pl: plaska rama 60, szprosy 22 w tej samej plaszczyznie,
        const fw = 60, mw = 22, bev = 5;                // skos 5 mm wokol kazdej szybki, przez szybe widac ciemne wnetrze szafki
        const iw = W - 2 * fw, ih = H - 2 * fw;
        const c = W < 330 ? 1 : W <= 450 ? 2 : 3, r = Math.max(1, Math.ceil(ih / 230));   // 40x80 = 2x3, 40x40 = 2x2
        const cw = (iw - (c - 1) * mw) / c, rh = (ih - (r - 1) * mw) / r;
        defs += `<linearGradient id="${P}gs" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#4E5456"/><stop offset=".55" stop-color="#6A7072"/><stop offset="1" stop-color="#7C8284"/></linearGradient>`;
        for (let i = 0; i < c; i++) for (let j = 0; j < r; j++) {
          const x = fw + i * (cw + mw), y = fw + j * (rh + mw);
          g += rect(x, y, cw, rh, mix(base, -.06), ' rx="2"')                                   // skos wokol szyby
            + ln(x, y, x + cw, y, SH, lw(1)) + ln(x, y, x, y + rh, SH, lw(1)) + ln(x, y + rh, x + cw, y + rh, HL, lw(.8)) + ln(x + cw, y, x + cw, y + rh, HL, lw(.8))
            + rect(x + bev, y + bev, cw - 2 * bev, rh - 2 * bev, `url(#${P}gs)`, ' rx="1.5"')      // szyba
            + ln(x + bev, y + bev + .6, x + cw - bev, y + bev + .6, "#2F3436", lw(.9)) + ln(x + bev + .6, y + bev, x + bev + .6, y + rh - bev, "#2F3436", lw(.9))
            + `<path d="M${x + bev + (cw - 2 * bev) * .12} ${y + rh - bev} L${x + bev + (cw - 2 * bev) * .62} ${y + bev}" stroke="#fff" stroke-opacity=".10" stroke-width="${(cw - 2 * bev) * .16}"/>`;
        }
        break;
      }
    }
    if (S.hinge && !/^knf-(t\d|z\d|pip)/.test(P)) {   // zawiasy sa z tylu frontu: puszki O35 linia przerywana, jak niewidoczne krawedzie
      const x = S.hinge === "Prawa" ? W - 22 : 22, ys = H > 1300 ? [100, H / 2, H - 100] : [100, H - 100];
      const hc = lum(base) < .45 ? "#ffffff" : "#22272B";
      ys.forEach(y => { if (y > 20 && y < H - 20) g += `<circle cx="${x}" cy="${y}" r="17.5" fill="none" stroke="${hc}" stroke-opacity=".55" stroke-width="${lw(1)}" stroke-dasharray="${4 * k} ${3 * k}"/>`; });
    }
    if (S.gloss) {
      defs += `<linearGradient id="${P}gl" x1="0" y1="0" x2="1" y2="1"><stop offset=".25" stop-color="#fff" stop-opacity="0"/><stop offset=".42" stop-color="#fff" stop-opacity=".42"/><stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset=".62" stop-color="#fff" stop-opacity=".18"/><stop offset=".7" stop-color="#fff" stop-opacity="0"/></linearGradient>`;
      g += rect(0, 0, W, H, `url(#${P}gl)`);
    }
    g += `<rect width="${W}" height="${H}" rx="1" fill="none" stroke="${mix(wood ? "#9A8568" : base, -.32)}" stroke-width="${lw(.9)}"/>`;
    return { defs, g };
  }

  const REDUCE = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const lerpHex = (a, b, e) => {
    const pa = parseInt(a.slice(1), 16), pb = parseInt(b.slice(1), 16);
    const ch = sh => Math.round(((pa >> sh) & 255) + ((((pb >> sh) & 255) - ((pa >> sh) & 255)) * e));
    return "#" + [16, 8, 0].map(sh => ch(sh).toString(16).padStart(2, "0")).join("");
  };
  const isHex = h => /^#[0-9a-f]{6}$/i.test(h);
  let cur = null, anim = 0, lastSig = "";

  /* Zmiana wymiaru albo koloru przechodzi plynnie (280 ms), zamiast przeskakiwac. */
  function draw() {
    const S = readState();
    const has = S.szer >= 40 && S.wys >= 40;
    const T = { W: has ? S.szer : 597, H: has ? S.wys : 797, hex: isHex(S.hex) ? S.hex : "#ECEBE6" };
    const box = sheet.getBoundingClientRect();
    const sig = JSON.stringify(S) + "|" + Math.round(box.width) + "x" + Math.round(box.height) + "|" + pip.classList.contains("is-on");
    if (sig === lastSig) return;          // nic sie nie zmienilo (np. ilosc, uwagi, dokowanie paska) - nie przerysowuj
    lastSig = sig;
    renderTiles(S);
    const moved = !cur || cur.W !== T.W || cur.H !== T.H || cur.hex !== T.hex;
    cancelAnimationFrame(anim);
    if (!cur || !moved || REDUCE || document.hidden) { cur = T; render(S, T, has); return; }
    const from = { ...cur }, t0 = performance.now(), D = 280;
    const step = now => {
      const p = Math.max(0, Math.min(1, (now - t0) / D)), e = 1 - Math.pow(1 - p, 3);   // wer3: klatka sprzed t0 dawala p<0 i ujemne wymiary SVG
      cur = { W: from.W + (T.W - from.W) * e, H: from.H + (T.H - from.H) * e, hex: lerpHex(from.hex, T.hex, e) };
      render(S, cur, has);
      if (p < 1) anim = requestAnimationFrame(step); else cur = T;
    };
    anim = requestAnimationFrame(step);
  }

  function render(S0, C, has) {
    const S = { ...S0, hex: C.hex }, W = C.W, H = C.H;
    const customSel = !!root.querySelector(".knf__color--custom.is-active");
    const color = catOf(S.style) === "lakier" ? (customSel ? S.custom : S.colorLabel) : "";
    if (identStyle) identStyle.textContent = S.styleLabel || "";
    const sub = [color, smoothLow(S.style, S.szer, S.wys) ? LOW_TXT : ""].filter(Boolean).join(" · ");
    if (identSub) { identSub.textContent = sub; identSub.hidden = !sub; }
    if (cap) cap.textContent = S.sample ? "" : [S.sys, S.typ].filter(Boolean).join(", ");
    if (note) note.textContent = note.textContent.replace(/\d+\s*mm/, S.grub + " mm");
    const box = sheet.getBoundingClientRect();
    sheet.classList.toggle("is-tiny", box.height > 0 && box.height < 120);   // wer3: za malo miejsca na rysunek - zostaje sam podpis
    if (box.width && box.height) {
      // u gory podpis (nazwa stylu, kolor), u dolu podpisy rogow - front rysujemy w tym, co zostaje
      const identEl = sheet.querySelector(".knf__ident");
      const capH = Math.max(cap ? cap.offsetHeight : 0, note && note.offsetParent ? note.offsetHeight : 0);
      const topPx = identEl ? identEl.offsetHeight + 16 : 0, botPx = capH + 20;
      const availH = Math.max(60, box.height - topPx - botPx);
      const ar = box.width / availH, M = Math.max(W, H);
      // podpis wymiaru stoi ok. 40 px od frontu - margines musi go zmiescic przy kazdej skali (wer2 24.09: wchodzil na podpisy dolne)
      let pad = M * (M > 1500 ? .07 : .16) + 50, vw, vh, k;
      for (let i = 0; i < 4; i++) {
        vw = W + pad * 2; vh = H + pad * 2;
        if (vw / vh < ar) vw = vh * ar; else vh = vw / ar;
        k = vw / box.width;
        if (!has || pad >= 46 * k) break;
        pad = 48 * k;
      }
      const ox = (vw - W) / 2, oy = (vh - H) / 2 + topPx * k;
      vh += (topPx + botPx) * k;
      const { defs, g } = frontSVG(S, W, H, k);
      const cs = getComputedStyle(root), acc = cs.getPropertyValue("--knf-mdf").trim() || "#9C7A52", ink = cs.getPropertyValue("--knf-text").trim() || "#22272B";
      const sw = 1.1 * k, fs = 13 * k, gap = 22 * k, t = 6 * k, ext = 8 * k, dy = H + gap, dx = W + gap;
      const dim = has && !S.virt ? `<g stroke="${acc}" stroke-width="${sw}" fill="none">
        <line x1="0" y1="${H + 4 * k}" x2="0" y2="${dy + ext}"/><line x1="${W}" y1="${H + 4 * k}" x2="${W}" y2="${dy + ext}"/>
        <line x1="0" y1="${dy}" x2="${W}" y2="${dy}"/>
        <line x1="${-t / 2}" y1="${dy + t / 2}" x2="${t / 2}" y2="${dy - t / 2}"/><line x1="${W - t / 2}" y1="${dy + t / 2}" x2="${W + t / 2}" y2="${dy - t / 2}"/>
        <line x1="${W + 4 * k}" y1="0" x2="${dx + ext}" y2="0"/><line x1="${W + 4 * k}" y1="${H}" x2="${dx + ext}" y2="${H}"/>
        <line x1="${dx}" y1="0" x2="${dx}" y2="${H}"/>
        <line x1="${dx - t / 2}" y1="${t / 2}" x2="${dx + t / 2}" y2="${-t / 2}"/><line x1="${dx - t / 2}" y1="${H + t / 2}" x2="${dx + t / 2}" y2="${H - t / 2}"/></g>
        <g fill="${ink}" font-family="inherit" font-size="${fs}" style="font-variant-numeric:tabular-nums">
        <text x="${W / 2}" y="${dy + fs * 1.35}" text-anchor="middle">${S.szer} mm</text>
        <text x="${dx + fs * .9}" y="${H / 2}" text-anchor="middle" transform="rotate(90 ${dx + fs * .9} ${H / 2})">${S.wys} mm</text></g>` : "";
      svg.setAttribute("viewBox", `${-ox} ${-oy} ${vw} ${vh}`);
      svg.innerHTML = `<defs>${defs}</defs><rect x="${6 * k}" y="${9 * k}" width="${W}" height="${H}" rx="1" fill="#000" opacity=".07"/><g>${g}</g>${dim}`;
    }
    sheet.classList.toggle("is-empty", !has);
    renderPip(S, W, H, color, has);
  }

  /* Miniatury stylow: ten sam rysunek co duzy, w kolorze wybranym przez klienta (fornir i sklejka z faktura).
     Zdjecie z metafieldu zostaje w DOM (alt, fallback), jest tylko schowane. */
  let tileSig = "", tileHex = "#ECEBE6";
  function renderTiles(S) {
    if (catOf(S.style) === "lakier" && !S.customOn && isHex(S.hex)) tileHex = S.hex;
    const sig = tileHex;
    const tiles = root.querySelectorAll(".knf__style[data-style]");
    if (!tiles.length) return;
    const fresh = Array.from(tiles).some(t => !t.querySelector(".knf__style-svg"));
    if (sig === tileSig && !fresh) return;
    tileSig = sig;
    tiles.forEach((t, i) => {
      let sv = t.querySelector(".knf__style-svg");
      if (!sv) {
        sv = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        sv.setAttribute("class", "knf__style-svg");
        sv.setAttribute("aria-hidden", "true");
        sv.setAttribute("viewBox", "-120 -60 837 917");
        const img = t.querySelector(".knf__style-img");
        img ? img.insertAdjacentElement("beforebegin", sv) : t.prepend(sv);
        t.classList.add("has-svg");
      }
      const TS = { style: t.dataset.style, hex: tileHex, loc: "Góra", horiz: false, gloss: false, customOn: false, locCustom: false };
      const { defs, g } = frontSVG(TS, 597, 797, 917 / 100, `knf-t${i}-`);
      sv.innerHTML = `<defs>${defs}</defs><rect x="14" y="20" width="597" height="797" fill="#000" opacity=".06"/>${g}`;
    });
  }

  /* Miniatura pozycji listy „Twój zestaw” (konfigurator-natywny.js, renderSetRow): front w skali w ramce w×h px,
     lekka faktura "m", bez zawiasow. i = numer wiersza (unikalne id w defs: knf-z{i}-). Zwraca string <svg>. */
  window.knfMini = (o, w, h, i) => {
    o = o || {}; w = +w || 32; h = +h || 40;
    const W = Math.max(40, +o.szer || 597), H = Math.max(40, +o.wys || 797);
    const pad = Math.max(W, H) * .06, ar = w / h;
    let vw = W + pad * 2, vh = H + pad * 2; if (vw / vh < ar) vw = vh * ar; else vh = vw / ar;
    const S = { style: o.style || "", hex: isHex(o.hex || "") ? o.hex : "#ECEBE6", loc: o.loc || "Góra", hinge: "", horiz: !!o.horiz, gloss: !!o.gloss, tex: o.tex,
      customOn: !!o.customOn, locCustom: !!o.locCustom || /^Niestandardow/.test(o.loc || "") || /^(Cok[oó]ł|Panel|Listwa|Blenda)/.test(o.typ || "") };
    const { defs, g } = frontSVG(S, W, H, vw / w, `knf-z${(+i || 0)}-`);
    return `<svg class="knf__mini-svg" aria-hidden="true" focusable="false" width="${w}" height="${h}" viewBox="${-(vw - W) / 2} ${-(vh - H) / 2} ${vw} ${vh}"><defs>${defs}</defs>${g}</svg>`;
  };

  /* Telefon: gdy duzy rysunek zjedzie z ekranu, u gory wysuwa sie pasek z miniatura frontu,
     zeby klient widzial efekt wyboru koloru i wymiaru bez przewijania w gore. Klik = powrot do rysunku. */
  const pip = document.createElement("button");
  pip.type = "button";
  pip.className = "knf__pip";
  pip.setAttribute("data-knf-pip", "");
  pip.setAttribute("tabindex", "-1");
  pip.setAttribute("aria-hidden", "true");
  pip.innerHTML = '<svg class="knf__pip-svg" aria-hidden="true"></svg><span class="knf__pip-t"><strong></strong><span></span></span><span class="knf__pip-dim"></span>';
  root.appendChild(pip);
  pip.addEventListener("click", () => sheet.scrollIntoView({ behavior: REDUCE ? "auto" : "smooth", block: "center" }));
  function renderPip(S, W, H, color, has) {
    const ps = pip.querySelector("svg"), box = ps.getBoundingClientRect();
    if (box.width) {
      const pad = Math.max(W, H) * .08, vw = W + pad * 2, vh = H + pad * 2, ar = box.width / box.height;
      let w = vw, h = vh; if (w / h < ar) w = h * ar; else h = w / ar;
      const k = w / box.width, { defs, g } = frontSVG(S, W, H, k, "knf-pip-");
      ps.setAttribute("viewBox", `${-(w - W) / 2} ${-(h - H) / 2} ${w} ${h}`);
      ps.innerHTML = `<defs>${defs}</defs>${g}`;
    }
    pip.querySelector("strong").textContent = S.styleLabel || "";
    pip.querySelector(".knf__pip-t > span").textContent = color;
    pip.querySelector(".knf__pip-dim").textContent = has && !S.virt ? `${S.szer} × ${S.wys} mm` : "";
  }
  if ("IntersectionObserver" in window) {
    let sheetGone = false, knfIn = false, editing = false;
    const MQ = window.matchMedia("(max-width: 989px)");
    const apply = () => pip.classList.toggle("is-on", MQ.matches && window.innerHeight >= 520 && sheetGone && knfIn && !editing
      && !root.classList.contains("knf--added") && !document.querySelector("dialog[open]"));
    new MutationObserver(apply).observe(root, { attributes: true, attributeFilter: ["class"] });
    window.addEventListener("resize", apply, { passive: true });
    // klawiatura ekranowa (pola mm, uwagi, kolor wlasny): pasek znika, jak pasek z cena w bindStickyCta
    const isField = el => el && el.matches && el.matches("input:not([type=hidden]), textarea");
    root.addEventListener("focusin", e => { if (isField(e.target)) { editing = true; apply(); } });
    root.addEventListener("focusout", () => setTimeout(() => { editing = isField(document.activeElement) && root.contains(document.activeElement); apply(); }, 200));
    new IntersectionObserver(([e]) => { sheetGone = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }, { rootMargin: "-80px 0px 0px 0px" }).observe(sheet);
    new IntersectionObserver(([e]) => { knfIn = e.isIntersecting; apply(); }, { rootMargin: "0px 0px -40% 0px" }).observe(root.querySelector(".knf__steps") || root);
    MQ.addEventListener ? MQ.addEventListener("change", apply) : MQ.addListener(apply);
  }

  /* Cena: krotkie mrugniecie przy zmianie, zeby klient zauwazyl, ze wybor ja zmienil */
  const priceEl = root.querySelector("[data-knf-price]");
  if (priceEl) {
    let prev = priceEl.textContent;
    new MutationObserver(() => {
      const now = priceEl.textContent;
      if (now === prev) return; prev = now;
      priceEl.classList.remove("is-bump"); void priceEl.offsetWidth; priceEl.classList.add("is-bump");
    }).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  /* Rzedy przewijane w bok (telefon): po zaladowaniu i przywroceniu konfiguracji wybrany kafelek ma byc widoczny */
  const seen = new WeakMap();
  function revealActive(onlyChanged) {
    root.querySelectorAll(".knf__styles, .knf__colors").forEach(sc => {   // presety, typy i systemy zawijaja sie (zestaw), nie przewijaja w bok
      const first = sc.firstElementChild;
      if (onlyChanged && seen.get(sc) === first) return;   // JS przerysowal rzad = nowe dzieci
      seen.set(sc, first);
      const a = sc.querySelector(".is-active");
      if (!a) { sc.scrollLeft = 0; return; }   // wer2 24.09: przyciaganie (snap) ustawialo rzad presetow o kolumne w prawo
      if (sc.scrollWidth <= sc.clientWidth) return;
      const left = a.offsetLeft - sc.offsetLeft - (sc.clientWidth - a.offsetWidth) / 2;
      sc.scrollLeft = Math.max(0, left);
    });
  }
  setTimeout(() => revealActive(false), 900);

  /* Przełączniki zamiast list rozwijanych: select zostaje (formularz, restore, walidacja), jest tylko schowany. */
  function enhanceSelects() {
    root.querySelectorAll("select[data-knf-cond], select[data-knf-strona], select[data-knf-grubadd]").forEach(sel => {   // 04.10.2026: + grubosc dodawanych elementow
      if (sel.options.length > 8) return;   // 24.09: Round ma 7 polozen uchwytu (z rogami)
      if (sel.hasAttribute("data-knf-noseg")) {   // UX v2 (03.10): uchwyt w linii nad kafelkami zestawu zostaje lista rozwijana
        const sg = sel.nextElementSibling;
        if (sg && sg.classList.contains("knf__seg")) { sg.remove(); sel.classList.remove("knf__sel-hidden"); sel.removeAttribute("tabindex"); sel.removeAttribute("aria-hidden"); }
        return;
      }
      let seg = sel.nextElementSibling && sel.nextElementSibling.classList.contains("knf__seg") ? sel.nextElementSibling : null;
      const sig = Array.from(sel.options).map(o => o.value + "|" + o.text).join(";");
      if (!seg || seg.dataset.sig !== sig) {
        seg && seg.remove();
        seg = document.createElement("div");
        seg.className = "knf__seg";
        seg.setAttribute("role", "radiogroup");
        seg.dataset.sig = sig;
        const lbl = sel.closest(".knf__col")?.querySelector(".knf__label");
        if (lbl) seg.setAttribute("aria-label", lbl.textContent.trim());
        // pusta opcja tylko z data-seg="1" (zawiasy opcjonalne: „Bez znaczenia”), reszta pustych to placeholdery
        seg.innerHTML = Array.from(sel.options).filter(o => o.value !== "" || o.dataset.seg === "1").map(o => `<button type="button" class="knf__seg-btn" role="radio" data-v="${o.value.replace(/"/g, "&quot;")}">${o.text.replace(/</g, "&lt;")}</button>`).join("");
        seg.addEventListener("keydown", e => {
          if (!/^Arrow(Left|Right|Up|Down)$/.test(e.key)) return;
          const bs = [...seg.querySelectorAll(".knf__seg-btn:not(:disabled)")]; if (!bs.length) return;
          const i = bs.indexOf(document.activeElement), d = /Right|Down/.test(e.key) ? 1 : -1;
          const nb = bs[(i + d + bs.length) % bs.length]; e.preventDefault(); nb.focus(); nb.click();
        });
        seg.addEventListener("click", e => {
          const b = e.target.closest(".knf__seg-btn"); if (!b || sel.disabled) return;
          if (sel.value !== b.dataset.v) { sel.value = b.dataset.v; sel.dispatchEvent(new Event("change", { bubbles: true })); }
          sync(sel, seg);
        });
        sel.insertAdjacentElement("afterend", seg);
        sel.classList.add("knf__sel-hidden");
        sel.setAttribute("tabindex", "-1");
        sel.setAttribute("aria-hidden", "true");
        if (!sel.dataset.knfSegBound) { sel.dataset.knfSegBound = "1"; sel.addEventListener("change", () => sync(sel, sel.nextElementSibling)); }
      }
      sync(sel, seg);
    });
  }
  function sync(sel, seg) {
    if (!seg || !seg.classList.contains("knf__seg")) return;
    const bs = [...seg.querySelectorAll(".knf__seg-btn")], hasSel = bs.some(b => b.dataset.v === sel.value);
    bs.forEach((b, i) => {
      const on = b.dataset.v === sel.value;
      b.setAttribute("aria-checked", String(on));
      b.disabled = sel.disabled;
      b.tabIndex = on || (!hasSel && i === 0) ? 0 : -1;   // jeden Tab na grupe (wzorzec ARIA radio group)
    });
  }

  /* Wymiary: przelicznik na cm obok etykiety pola i ostrzezenie, gdy ktos wpisze centymetry (60 × 80 zamiast 600 × 800).
     24.09: w polu obok „mm” czytal sie jak „31,7 cm mm”, wiec stoi przy etykiecie (uwaga Konrada) */
  const cmF = v => (v / 10).toLocaleString("pl", { maximumFractionDigits: 1 });   // wer3: przecinek jak w etykietach pol (pl/de/cs)
  const CMT = {
    pl: { warn: (a, b) => `Wpisano ${a} × ${b} mm, czyli ${cmF(a)} × ${cmF(b)} cm. Chodziło o ${a * 10} × ${b * 10} mm?`, fix: "Tak, zamień" },
    en: { warn: (a, b) => `You entered ${a} × ${b} mm (${a / 10} × ${b / 10} cm). Did you mean ${a * 10} × ${b * 10} mm?`, fix: "Yes, change" },
    de: { warn: (a, b) => `Eingegeben: ${a} × ${b} mm (${cmF(a)} × ${cmF(b)} cm). Meinten Sie ${a * 10} × ${b * 10} mm?`, fix: "Ja, ändern" },
    cs: { warn: (a, b) => `Zadáno ${a} × ${b} mm (${cmF(a)} × ${cmF(b)} cm). Mysleli jste ${a * 10} × ${b * 10} mm?`, fix: "Ano, změnit" }
  }[root.dataset.locale] || null;
  function dimHelp() {
    const inS = root.querySelector("[data-knf-szer]"), inW = root.querySelector("[data-knf-wys]");
    if (!inS || !inW || !CMT) return;
    [inS, inW].forEach(inp => {
      const lab = root.querySelector(`label[for="${inp.id}"]`); if (!lab) return;
      let h = lab.querySelector(".knf__cm");
      if (!h) { h = document.createElement("span"); h.className = "knf__cm"; lab.appendChild(h); }
      const v = parseInt(inp.value, 10);
      const txt = v > 0 ? `${(v / 10).toLocaleString(root.dataset.locale === "en" ? "en" : "pl", { maximumFractionDigits: 1 })} cm` : "";
      if (h.textContent !== txt) h.textContent = txt;   // zapis tylko przy zmianie - inaczej obserwator budzi sie w kolko
    });
    const a = parseInt(inS.value, 10), b = parseInt(inW.value, 10);
    const wrap = root.querySelector("[data-knf-dims-manual]");
    let w = root.querySelector("[data-knf-cmwarn]");
    const show = a > 0 && b > 0 && a < 250 && b < 250 && !inS.readOnly;
    if (show && !w && wrap) {
      w = document.createElement("div"); w.className = "knf__cmwarn"; w.setAttribute("data-knf-cmwarn", ""); w.setAttribute("role", "status");
      w.innerHTML = '<span></span><button type="button" class="knf__seg-btn"></button>';
      w.querySelector("button").addEventListener("click", () => {
        [inS, inW].forEach(i => { i.value = String(parseInt(i.value, 10) * 10); i.dispatchEvent(new Event("input", { bubbles: true })); i.dispatchEvent(new Event("change", { bubbles: true })); });
      });
      wrap.after(w);
    }
    if (w) {
      if (w.hidden !== !show) w.hidden = !show;
      if (show) {
        const sp = w.querySelector("span"), bt = w.querySelector("button"), msg = CMT.warn(a, b);
        if (sp.textContent !== msg) sp.textContent = msg;
        if (bt.textContent !== CMT.fix) bt.textContent = CMT.fix;
      }
    }
  }

  /* Presety wymiarow na telefonie: dwa rzedy czytane normalnie (lewo -> prawo), liczba kolumn z liczby presetow */
  function presetCols() {
    const pw = root.querySelector("[data-knf-presets]"); if (!pw) return;
    // zestaw: kafelki w .knf__pgrid (siatka z CSS) - bez --knf-pn; stara sciezka (SET_MODE = false) dalej dwa rzedy
    if (pw.querySelector(".knf__pgrid")) pw.style.removeProperty("--knf-pn");
    else pw.style.setProperty("--knf-pn", Math.max(1, Math.ceil(pw.querySelectorAll(".knf__preset").length / 2)));
    // 24.09 (Konrad): typy i kolory w rownych rzedach (8 typow = 4+4, 14 kolorow = 7+7), nie 6+2 / 9+5
    const cols = (el, n, max) => { const v = String(Math.max(1, Math.ceil(n / Math.ceil(Math.max(1, n) / max)))); if (el.style.getPropertyValue("--knf-c") !== v) el.style.setProperty("--knf-c", v); };
    root.querySelectorAll(".knf__typgrid-row").forEach(r => cols(r, r.querySelectorAll(".knf__typchip").length, 6));
    const cw = root.querySelector(".knf__colors");
    if (cw) cols(cw, cw.querySelectorAll(".knf__color[data-color]:not(.knf__color--custom)").length, 8);
  }

  let raf = 0, typing = 0;
  const schedule = e => {
    // wpisywanie mm: rysuj po chwili przerwy, nie przy kazdej cyfrze (front 6 mm z otworem poza obrysem)
    if (e && e.type === "input" && e.target && e.target.matches && e.target.matches("[data-knf-szer], [data-knf-wys]")) {
      dimHelp(); clearTimeout(typing); typing = setTimeout(() => schedule(), 280); return;
    }
    if (e && e.target && e.target.closest && e.target.closest("[data-knf-set]")) return;   // ilosc i uwagi w liscie zestawu nie zmieniaja rysunku
    if (raf) return;
    raf = requestAnimationFrame(() => { raf = 0; enhanceSelects(); presetCols(); dimHelp(); draw(); revealActive(true); });
  };
  // szkielety kafelkow z szablonu: jesli JS konfiguratora ich nie zastapil (np. deep link bez stylu), usun je
  setTimeout(() => {
    root.querySelectorAll(".knf__colors > span.knf__color, .knf__styles > span.knf__style, .knf__sysgrid > span.knf__syschip").forEach(x => x.remove());
    const dc = root.querySelector("[data-knf-color-detail]");
    if (dc && !dc.innerHTML.trim()) dc.hidden = true;
  }, 2500);
  new MutationObserver(ms => {
    if (ms.every(m => sheet.contains(m.target) || (m.target.closest && m.target.closest("[data-knf-ident], .knf__seg, [data-knf-pip], [data-knf-price], [data-knf-cmwarn], .knf__cm"
      + ", [data-knf-set], .knf__tile-count, .knf__tile-split, [data-knf-ask], [data-knf-live], [data-knf-nad-out]")))) return;
    schedule();
  }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ["class", "hidden", "disabled"] });
  root.addEventListener("input", schedule);
  root.addEventListener("change", schedule);
  if ("ResizeObserver" in window) new ResizeObserver(schedule).observe(sheet);
  schedule();
})();
